module.exports = {
  all: ['teacherCode', 'name', 'followerCount', 'studentCount', 'reviewCount', 'level', 'feeDiscount', 'feeDiscountRemaining', 'feeDiscountExpired', 'command'],
  verified: ['teacherCode', 'name', 'followerCount', 'studentCount', 'reviewCount', 'level', 'totalRevenue', 'command'],
  not_verified: ['teacherCode', 'name'],
  pending: ['teacherCode', 'name', 'user.requestedDate'],
  pending_bank: ['teacherCode', 'name', 'bankAccountPendingDate', 'bankName', 'bankAccount', 'command'],
  pending_tax: ['teacherCode', 'name', 'taxInfoPendingDate', 'tax', 'command'],
  tow: ['teacherCode', 'name', 'followerCount', 'studentCount', 'reviewCount', 'level', 'feeDiscount', 'feeDiscountRemaining', 'feeDiscountExpired', 'command'],
  deleted: ['teacherCode', 'name'],
};
